// src/api/ordersApi.js
const API_BASE = process.env.REACT_APP_API_BASE_URL;
const token = () => localStorage.getItem("token");

/* ================== USER ORDERS (cliente) ================== */

export async function listUserOrders({
  page = 1,
  pageSize = 10,
  filters = {},
  tkn,
} = {}) {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("pageSize", String(pageSize));
  if (filters?.status && filters.status !== "all")
    params.set("status", filters.status);
  if (filters?.from) params.set("from", filters.from); // YYYY-MM-DD
  if (filters?.to) params.set("to", filters.to); // YYYY-MM-DD

  const res = await fetch(`${API_BASE}/api/orders?${params.toString()}`, {
    headers: { Authorization: `Bearer ${tkn || token()}` },
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || `HTTP ${res.status}`);
  }
  return await res.json(); // { data, page, totalPages }
}

export async function getOrderDetail(id, { tkn } = {}) {
  const res = await fetch(`${API_BASE}/api/orders/${id}`, {
    headers: { Authorization: `Bearer ${tkn || token()}` },
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || `HTTP ${res.status}`);
  }
  return await res.json();
}

/* ================== SUPPLIER ORDERS (fornitore/admin) ================== */

export async function listSupplierOrders({
  page = 1,
  pageSize = 10,
  filters = {},
  tkn,
  fornitore,
} = {}) {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("pageSize", String(pageSize));
  if (filters?.status && filters.status !== "all")
    params.set("status", filters.status);
  if (filters?.from) params.set("from", filters.from);
  if (filters?.to) params.set("to", filters.to);
  if (fornitore != null && String(fornitore).trim() !== "") {
    params.set("fornitore", String(fornitore)); // override admin
  }

  const url = `${API_BASE}/api/fornitore/orders?${params.toString()}`;
  const r = await fetch(url, {
    headers: { Authorization: `Bearer ${tkn || token()}` },
  });
  if (!r.ok)
    throw new Error((await r.text().catch(() => "")) || `HTTP ${r.status}`);
  return r.json(); // { data, page, totalPages }
}

export async function getSupplierOrderDetail(id, { tkn, fornitore } = {}) {
  const params = new URLSearchParams();
  if (fornitore != null && String(fornitore).trim() !== "") {
    params.set("fornitore", String(fornitore));
  }
  const qs = params.toString();
  const url = `${API_BASE}/api/fornitore/orders/${id}${qs ? `?${qs}` : ""}`;

  const r = await fetch(url, {
    headers: { Authorization: `Bearer ${tkn || token()}` },
  });
  if (!r.ok)
    throw new Error((await r.text().catch(() => "")) || `HTTP ${r.status}`);
  return r.json();
}

export async function updateSupplierOrderStatus(
  id,
  newStatus,
  { tkn, fornitore } = {}
) {
  const params = new URLSearchParams();
  if (fornitore != null && String(fornitore).trim() !== "") {
    params.set("fornitore", String(fornitore)); // idem
  }
  const qs = params.toString();
  const url = `${API_BASE}/api/fornitore/orders/${id}/status${
    qs ? `?${qs}` : ""
  }`;

  const r = await fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${tkn || token()}`,
    },
    body: JSON.stringify({ status: newStatus }),
  });
  const js = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(js.error || `HTTP ${r.status}`);
  return js; // { id, status }
}

/* ================== ADMIN ORDERS (tutti gli ordini) ================== */

export async function listAdminOrders({
  page = 1,
  pageSize = 10,
  filters = {},
  tkn,
} = {}) {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("pageSize", String(pageSize));

  if (filters?.status && filters.status !== "all")
    params.set("status", filters.status);
  if (filters?.from) params.set("from", filters.from);
  if (filters?.to) params.set("to", filters.to);
  if (filters?.cliente) params.set("cliente", filters.cliente);
  if (filters?.provincia) params.set("provincia", filters.provincia);
  if (filters?.citta) params.set("citta", filters.citta);
  if (filters?.fornitore) params.set("fornitore", filters.fornitore);

  const url = `${API_BASE}/api/admin/orders?${params.toString()}`;
  const r = await fetch(url, {
    headers: { Authorization: `Bearer ${tkn || token()}` },
  });

  if (!r.ok) {
    const text = await r.text().catch(() => "");
    throw new Error(text || `HTTP ${r.status}`);
  }

  return r.json(); // { data, page, totalPages }
}

export async function updateAdminOrderStatus(id, newStatus, { tkn } = {}) {
  const url = `${API_BASE}/api/admin/orders/${id}/status`;

  const r = await fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${tkn || token()}`,
    },
    body: JSON.stringify({ status: newStatus }),
  });

  const js = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(js.error || `HTTP ${r.status}`);
  return js; // { id, status }
}
